import { Component } from '@angular/core';

@Component({
  selector: 'lib-logo',
  standalone: true,
  imports: [],
  template: `<svg
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-35 h-9"
  >
    <path
      d="M0 28.4272H27.5444V0.882812H0V28.4272ZM17.6653 2.99436C22.5294 4.59688 26.055 9.19705 26.0739 14.6645C26.0927 20.0376 22.6426 24.6377 17.6653 26.3345V2.99436ZM13.7628 2.37221C14.6489 2.37221 15.5727 2.48533 16.3645 2.63615C16.3645 8.87651 10.3315 14.0046 4.09113 14.0046H1.4894C1.92301 7.61337 7.22075 2.37221 13.7628 2.37221ZM4.10998 15.3055C10.3315 15.3055 16.3645 20.4335 16.3645 26.6738C15.5915 26.8247 14.5923 26.9567 13.7628 26.9567C7.20191 26.9567 1.73449 21.6778 1.4894 15.3055H4.10998Z"
      fill="#fff"
    />
  </svg> `,
  styles: [],
})
export class LogoComponent {}
